import React from 'react';

import {
  CapaQuotationChatMessage,
  CapaQuotationChatMessageMessage
} from '@generated/graphql';

import { hyperlinkRegex } from '@utils/regex';

import useStyles from '../useStyles';

import { CustomizedTypography } from '@components/Customized';
import { clsx } from '@components/Provider';

const DefaultBubble = ({
  message,
  isOwner
}: {
  isOwner: boolean;
  message?: CapaQuotationChatMessage;
}) => {
  const classes = useStyles();
  const chatMessage = message?.message as CapaQuotationChatMessageMessage;
  const content = chatMessage.message ?? '';

  const matchedLink = content.match(hyperlinkRegex);

  const hyperLink = matchedLink && matchedLink[0].trim();

  const replace = hyperLink?.replace(hyperlinkRegex, (url, p1, p2) => {
    const converted = p2 === 'www.' ? `https://${url}` : p1;

    return converted;
  });
  return (
    <div
      className={clsx(classes['Chat-Message-Bubble-Common-root'], {
        owner: isOwner
      })}
    >
      <CustomizedTypography
        className="long-text"
        variant="body2"
        color="textPrimary"
      >
        {hyperLink ? (
          <>
            {content.split(hyperLink)[0]}
            <span className="hyperlink" onClick={() => window.open(replace)}>
              {hyperLink}
            </span>
            {content.split(hyperLink)[1]}
          </>
        ) : (
          content
        )}
      </CustomizedTypography>
    </div>
  );
};

export default DefaultBubble;
